export default __webpack_public_path__ + "static/media/roof.55f2d4aa.png";